import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Dropdown,
  Form,
  Image,
  InputGroup,
  Table,
} from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import nodataimage from "../../../assets/nodataimage.svg";
import dropdown from "../../../assets/dropdown.svg";
import { faFile, faFilter, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageHeading from "components/shared/PageHeading";
import {
  getAllSubmissions,
  getAssignmentDetails,
} from "services/Teacher/Assignments.service";
import moment from "moment";
import { useTranslation } from "react-i18next";
const Submissions = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const { exerciseId } = useParams();


  const searchParams = new URLSearchParams(location.search);
  const initialLimit = parseInt(searchParams.get("limit"), 10) || 3;
  const initialSearchQuery = searchParams.get("search") || "";

  const [submissions, setSubmissions] = useState([]);
  const [search, setSearch] = useState(initialSearchQuery);
  const [loading, setLoading] = useState(false);
  // Shown next to the "Submissions" heading so the teacher knows which
  // assignment they are looking at.
  const [assignmentTitle, setAssignmentTitle] = useState("");

  const limit = initialLimit;
  const exerciseIdParams = exerciseId ? exerciseId : params.id;
  const GetSubmissions = async (exerciseIdParams) => {
    setLoading(true);
    try {
      const response = await getAllSubmissions(exerciseIdParams);
      setSubmissions(response.data.results);
    } catch (error) {
      console.error("Error fetching submissions:", error);
      setSubmissions([]);
    } finally {
      setLoading(false);
    }
  };

  const GetAssignmentTitle = async (id) => {
    try {
      const response = await getAssignmentDetails(id);
      const assignment = response?.data?.results;
      setAssignmentTitle(
        assignment?.title ||
          assignment?.exercise?.title ||
          assignment?.studySet?.title ||
          ""
      );
    } catch (error) {
      console.error("Error fetching assignment details:", error);
      setAssignmentTitle("");
    }
  };

  useEffect(() => {
    if (exerciseIdParams) {
      // Fetch submissions using the exercise ID
      GetSubmissions(exerciseIdParams);
      GetAssignmentTitle(exerciseIdParams);
    }
  }, [exerciseIdParams]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  // The endpoint stamps every row with the exercise's question count.
  const questionCount =
    submissions.find((s) => s?.questionCount)?.questionCount || 0;

  // Display-only labels; the stored status values stay as they are.
  const getStatusLabel = (status) =>
    status === "pending" ? t("Not submitted") : status;

  const getRowBackgroundColor = (status) => {
    switch (status) {
      case "pending":
        return "#C4C4C4"; // grey - Not Attempted
      case "in-progress":
        return "#4DA9F4";
      case "submitted":
        return "#F5C518"; // yellow
      case "marked":
        return "#0FE133"; // green
      case "revise-needed":
        return "#EB3232"; // red - Revise Needed
      case "terminated":
        return "#EB3232";
      case "overdue":
        return "#dbdbdb";
      default:
        return "#B0BEC5";
    }
  };

  return (
    <>
      <div className="d-block d-lg-flex justify-content-between">
        <div>
          <PageHeading
            heading={"Submissions"}
            spanText={assignmentTitle ? `— ${assignmentTitle}` : ""}
          />
        </div>
        <div className="d-block d-lg-flex gap-3 justify-content-between">
          <div>
            <Button
              className="px-4 py-2 w-100 w-lg-auto my-lg-0 my-2"
              style={{
                color: "#858585",
                borderRadius: "30px",
                background: "white",
                border: "2px solid #858585",
                fontWeight: 600,
              }}
            >
              {t("Sort By")}
              <FontAwesomeIcon icon={faFilter} className="ms-2" />
            </Button>
          </div>
          <div>
            <Form.Group
              className="mb-3 position-relative"
              controlId="formBasicPassword"
            >
              <InputGroup className="mb-3">
                <Form.Control
                  type={"text"}
                  placeholder={t("Search Here...")}
                  className="px-3 py-2 border-right-0"
                  value={search}
                  onChange={handleSearchChange}

                  style={{
                    borderTopLeftRadius: "30px",
                    borderBottomLeftRadius: "30px",
                    borderColor: "#ea4f50",
                    borderRight: "0",
                  }}
                />
                <InputGroup.Text
                  id="basic-addon2"
                  className="bg-white "
                  style={{
                    cursor: "pointer",
                    borderTopRightRadius: "30px",
                    borderBottomRightRadius: "30px",
                    borderColor: "#ea4f50",
                    borderLeft: "0",
                  }}
                >
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
              </InputGroup>
            </Form.Group>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <Table responsive="sm" style={{ overflow: "auto" }}>
          <thead>
            <tr>
              <th style={{ color: "#303972" }}>{t("Student Name")}</th>
              <th style={{ color: "#303972" }}>{t("Submitted At")}</th>
              <th style={{ color: "#303972" }}>{t("Status")}</th>
              <th style={{ color: "#303972" }}>{t("Answered")}</th>
              <th style={{ color: "#303972" }}>{t("Actions")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              [...Array(limit)].map((_, index) => (
                <tr key={index}>
                  <td className="py-3">
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "20px",
                        width: "80%",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </td>

                  <td className="py-3">
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "20px",
                        width: "40%",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </td>
                  <td className="py-3">
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "20px",
                        width: "40%",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </td>
                  <td className="py-3">
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "20px",
                        width: "40%",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </td>
                  <td className="py-3">
                    <div
                      style={{
                        backgroundColor: "#e0e0e0",
                        height: "20px",
                        width: "40%",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </td>
                </tr>
              ))
            ) : submissions.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-3">
                  <Image src={nodataimage} />
                  <h5 className="text-secondary mt-2">{t("No submissions found")}</h5>
                </td>
              </tr>
            ) : (
              submissions.map((exercise, index) => (
                <tr key={exercise._id}>
                  <td className="py-3">
                    <span
                      style={{
                        color: "#303972",
                        fontWeight: 700,
                      }}
                    >
                      {exercise?.student?.fullName}
                    </span>
                  </td>
                  <td className="py-3" style={{ color: "#A098AE" }}>
                    {exercise?.submittedAt
                      ? moment(exercise.submittedAt).format("MMM D, YYYY")
                      : "—"}
                  </td>

                  <td className="py-3 " style={{ color: "#A098AE" }}>
                    <span
                      className="text-white"
                      style={{
                        background: getRowBackgroundColor(exercise.status),
                        borderRadius: "60px",
                        padding: "5px 10px",
                      }}
                    >
                      {" "}
                      {getStatusLabel(exercise.status)}
                    </span>
                  </td>
                  <td className="py-3" style={{ color: "#A098AE" }}>
                    <span style={{ fontSize: "13px" }}>
                      <span style={{ fontWeight: 700, color: "#303972" }}>
                        {exercise?.answers?.length || 0}
                      </span>
                      {questionCount ? ` / ${questionCount}` : ""}
                    </span>
                  </td>
                  <td className="py-3">
                    <Dropdown align="end">
                      <Dropdown.Toggle
                        className="more bg-transparent text-black border-0 e-caret-hide rounded-0"
                        id={`submission-actions-${exercise?._id}`}
                      >
                        <Card.Img
                          style={{ width: "24px", height: "24px" }}
                          variant="top"
                          src={dropdown}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        className="border-0"
                        style={{
                          boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
                        }}
                      >
                        {/* Placeholder rows have no submission to open. */}
                        {exercise?.isPlaceholder ? (
                          <Dropdown.Item disabled>
                            <FontAwesomeIcon icon={faFile} className="me-2" />
                            {t("Not submitted")}
                          </Dropdown.Item>
                        ) : (
                          <Dropdown.Item
                            style={{ color: "black" }}
                            onClick={() =>
                              navigate(
                                `/assignments/submissions/mark/${exercise?._id}`
                              )
                            }
                          >
                            <FontAwesomeIcon icon={faFile} className="me-2" />
                            {exercise.status === "submitted"
                              ? t("Mark Submission")
                              : t("View Submission")}
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default Submissions;
